import { createTheme } from "@mantine/core";

/**
 * Mantine theme.
 *
 * Spica (BootstrapDash) was evaluated and rejected: the free edition is
 * Bootstrap 4 + jQuery, which fights React's rendering model (ARCHITECTURE.md
 * §3). If its look is wanted later, lift its CSS as a reference here rather
 * than reintroducing jQuery.
 *
 * design-sparx/mantine-analytics-dashboard (MIT) was used the same way: a
 * design reference to lift specific values from, not a dependency. Its own
 * per-component `radius` overrides are skipped here — `defaultRadius` below
 * already cascades to every component that supports one, so repeating it per
 * component would just be the same value twice.
 */
export const theme = createTheme({
  primaryColor: "indigo",
  defaultRadius: "md",
  fontFamily:
    "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  headings: {
    fontWeight: "600",
  },
  components: {
    // Every existing `<Card withBorder>` picks this up automatically — a
    // default, not a per-usage prop, so cards gain a bit of separation from
    // the page without touching the ~10 places that render one. A Mantine
    // shadow token rather than a literal box-shadow value, so it stays
    // correct in dark mode without a second, dark-specific number.
    Card: {
      defaultProps: {
        shadow: "sm",
      },
    },
  },
});
